export const formatIsoString = (date) => {
  return new Date(date.split('T')[0].replace(/-/g, '/')).toISOString()
}
